<script setup lang="ts">
import { AnnuitiesPremium, policyIsType, PolicyType } from "@/entities/premium";
import GuaranteedPremium from "./GuaranteedPremium/GuaranteedPremium.vue";
import HandoffPremium from "./HandoffPremium/HandoffPremium.vue";
import IndicativePremium from "./IndicativePremium/IndicativePremium.vue";
import ErroredPremium from "./ErroredPremium/ErroredPremium.vue";
import ExpiryMessage from "@/components/ExpiryMessage.vue";
import { PaymentFrequency } from "@/stores/pensionOptions";
import { computed } from "vue";
import { getCompanyIdBySlug } from "@/utils";

const props = defineProps<{
    premium: AnnuitiesPremium;
    paymentFrequency: PaymentFrequency;
    quoteNumber: string;
}>();

defineEmits<{
    (on: "apply", premium: AnnuitiesPremium): void;
}>();

const companyId = computed(() => {
    return getCompanyIdBySlug(props.premium.company.slug);
});
</script>

<template>
    <div class="card single-result-card">
        <div class="result-container">
            <div
                :id="'heading_' + premium.premiumId"
                class="result-card-header"
            >
                <template v-if="policyIsType(premium, PolicyType.Guaranteed)">
                    <GuaranteedPremium
                        :premium="premium"
                        :payment-frequency="paymentFrequency"
                        :quote-number="quoteNumber"
                        :company-id="companyId"
                        @apply="$emit('apply', $event)"
                    />
                </template>
                <template v-else-if="policyIsType(premium, PolicyType.IndicativeAMS)">
                    <HandoffPremium
                        :premium="premium"
                        :payment-frequency="paymentFrequency"
                    />
                </template>
                <template v-else-if="policyIsType(premium, PolicyType.Indicative)">
                    <IndicativePremium
                        :premium="premium"
                        :payment-frequency="paymentFrequency"
                        :quote-number="quoteNumber"
                    />
                </template>
                <template v-else-if="policyIsType(premium, PolicyType.Error)">
                    <ErroredPremium
                        :premium="premium"
                    />
                </template>
            </div>
            <ExpiryMessage
                v-if="policyIsType(premium, PolicyType.Guaranteed)"
                :is-expired="premium.policy.isExpired || false"
                :expiry-date="premium.policy.expiryDate"
                responsive-classes="mobile-expiry"
            />
        </div>
    </div>
</template>

<style scoped>
.single-result-card {
    position: relative;
    margin-bottom: 20px;
    padding: 0px 15px;
}

.result-container {
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 15px;
    border-radius: 16px;
    border: 1px solid grey;
    background-color: #fff;
}

.result-card-header {
    width: 100%;
}

@media (min-width: 1200px) {
    .mobile-expiry {
        display: none;
    }
}
</style>
